"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../assets/css/font-face.css");

require("./Label.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Label = function Label(_ref) {
  var color = _ref.color,
      linear = _ref.linear,
      className = _ref.className,
      children = _ref.children;
  var wrapperClass = 'label';
  if (color === 'success') wrapperClass += ' label--success';
  if (color === 'danger') wrapperClass += ' label--danger';
  if (color === 'info') wrapperClass += ' label--info';
  if (linear) wrapperClass += ' label--linear';
  if (className) wrapperClass += " ".concat(className);
  return _react.default.createElement("div", {
    className: wrapperClass
  }, children);
};

Label.propTypes = {
  /** Cor do label */
  color: _propTypes.default.string,

  /** Classe adicional para o wrapper */
  className: _propTypes.default.string,

  /** Conteúdo do label */
  children: _propTypes.default.node,

  /** Define se terá preenchimento */
  linear: _propTypes.default.bool
};
var _default = Label;
exports.default = _default;